export class RegionFilterSettingsModel {
  public name: string;
}